<template>
  <div>
    <!-- LOGIN -->
    <!-- logo white -->
    <div
      class="d-flex flex-column-auto flex-column pt-lg-10 pt-10"
      v-if="place == 'login-white'"
    >
      <a
        href="#"
        class="text-center mb-3"
      >
        <img
          src="/images/logo-medhop-transparent.png"
          class="max-h-150px"
          alt=""
        />
      </a>
    </div>
    <!-- end logo white -->

    <!-- logo -->
    <div
      class="pb-13 pt-lg-0 pt-5 d-flex justify-content-center"
      v-if="place == 'login'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="280"
        max-height="150"
        alt=""
      />
    </div>
    <!-- end logo -->
    <!-- end LOGIN -->

    <!-- Print Medical Record -->
    <template v-if="place == 'print-medical-record'">
      <img :src="data.logo || '/images/logo-medhop-transparent.png'" width="300" class="mt-8" alt="Logo" />
    </template>

    <!-- General -->
    <!-- brand logo -->
    <div
      class="brand-logo medhop-sidebar-logo"
      v-if="place == 'brand'"
    >
      <router-link to="/">
        <img
          :src="brandLogo"
          alt="Logo klinik"
          @error="useMedhopLogo"
        />
        <small>Powered by Medhop</small>
      </router-link>
    </div>
    <!-- end brand logo -->
    <!-- end General -->

    <!-- print out section -->
    <!-- medical record -->
    <div
      class="col-md-12 d-flex justify-content-center"
      v-if="place == 'logo-themplate'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="300"
        class="mt-8"
        alt="Logo"
      />
    </div>
    <!-- end medical record -->

    <!-- invoice -->
    <div class="d-flex justify-content-center">
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        height="60"
        style="margin-left: -10px"
        v-if="place == 'logo-invoice'"
      />
    </div>
    <!-- end invoice -->

    <!-- invoice thermal print-->
    <div class="d-flex justify-content-center">
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        height="130"
        style="margin-left: -10px"
        v-if="place == 'logo-invoice-thermal-print'"
      />
    </div>
    <!-- end invoice -->

    <!-- po invoice -->
    <div
      class="d-flex justify-content-end logo-po"
      v-if="place == 'logo-po'"
    >
      <img
        :src="data.logo || '/images/logo-medhop-transparent.png'"
        width="200"
      />
    </div>
    
    <!-- end po invoice -->

    <!-- logo default Medhop -->
    <div
      class="d-flex justify-content-end"
      v-if="place == 'logo-default'"
    >
      <img
        src="/images/logo-medhop-transparent.png"
        width="150"
        class="my-2"
      />
    </div>
    <!-- end logo default medhop -->

    <!-- end print out section -->
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import { setConfiguration, getConfiguration } from "@/core/services/jwt.service.js";

export default {
  props: {
    height: Number,
    width: Number,
    place: String,
  },

  data() {
    return {
      // data
      primary: "/images/logo-medhop-transparent.png",
      data: getConfiguration() != null ? getConfiguration() : '',

    };
  },
  methods: {
    useMedhopLogo(event) {
      event.target.src = "/images/logo-medhop-transparent.png"
    },
    async get() {
      this.data = await module.get("settings-no-auth/1");
    },

    async getSetting() {
      let dbconfiguration = JSON.parse(localStorage.getItem("dbconfiguration"))
      let response = await module.get("settings-no-auth/1")
      if (response != null) {
        setConfiguration(JSON.stringify(response))
        this.data = response
      }
    },
  },
  computed: {
    brandLogo() {
      return (this.data && (this.data.brand_logo || this.data.logo)) || "/images/logo-medhop-transparent.png"
    },
  },
  mounted() {
    if (this.data == '') {
      this.getSetting()
    }
    

    this.$root.$on("configurationEditSuccessfully", () => {
      this.get()
    });
  }
};
</script>

<style lang="scss" scoped>
.medhop-sidebar-logo { min-width: 0; flex: 1; }
.medhop-sidebar-logo a { display: flex; min-width: 0; align-items: center; flex-direction: column; justify-content: center; text-decoration: none; }
.medhop-sidebar-logo img { display: block; width: auto; max-width: 132px; height: auto; max-height: 43px; object-fit: contain; }
.medhop-sidebar-logo small { margin-top: 2px; color: #7c8da2; font-size: 8px; font-weight: 600; letter-spacing: .02em; line-height: 1; }
</style>
